/* eslint-disable */
import { useReactToPrint } from 'react-to-print';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';

const CustomReportPDFandPrint = (props) => {
    const pdfIcon = <FontAwesomeIcon icon={faFilePdf} />;

    const handlePrint = useReactToPrint({
        contentRef: props.componentRefs,
        documentTitle: "PDCustomReport.pdf",
    });

    const getPDFButton = () => (
        <span className="hide-on-print">
            <button
                id="industryPdfButton"
                className="print-pdf-btn"
                onClick={handlePrint}
                aria-hidden="true"
            >
                {pdfIcon}
            </button>
        </span>
    );

    return <>{getPDFButton()}</>;
}
export default CustomReportPDFandPrint;
